export default{
  common:{
    investigator:'Investigator',
    appTitle:'Trial Introduction',
    itemName: 'Early Antiplatelet for Minor Stroke following Thrombolysis',
    researchFiles:"Research Files",
    protocol:'Protocol',
    protocolPublished:'Published Protocol',
    plan:'Statistical Analysis Plan',
    informedConset:'Informed Conset Form',
    dataCommittee:'Data Monitoring Committee',
    steeringCommittee:'Trial Steering Committee',
    trialSteeringCommittee:'Trial Steering Committee',
    institutionHumanResearchEthicsCommittee:'Institution Human Research Ethics Committee',
    dataMonitoringCommittee:'Data Monitoring Committee',
    outcomeCommittee:'Outcome Committee',
    principalInvestigator:'Introduction to Principal Investigator',
    principalInvestigatorSite:'Introduction to Principal Investigation Site',
    supportPlatform:'Electronic Data Capture System',
    introductiontoAssociation:'Introduction to Association',
    ConnectPI:'Connect to Principal Investigator',
    ConnectPM:'Connect to Project Manager',
    projectIntroduction:'Introduction to Projects Researching',
    projectIntroductionInMS:'Introduction to Projects in Meisi',
    recruitingProcess:'Recruiting Process',
    recruitingSites:'Recruiting Sites',
    recruitingCases:'Cumulative Recruiting Cases',
    newRecruitingCases:'New Recruiting Cases',
    cases:'Recruiting number',
    recruitingNumber:'Recruiting number',
    people:'people',
    sixMonths:'In 6 months',
    oneYear:'In 1 year',
    twoYear:'In 2 year',
    range:'Range',
    dateStart: 'Start date',
		dateEnd: 'End date',
    sitesRanking:'Sites Ranking and Co-Principal Investigator',
		confirm: 'Confirm',
    showMore:'View more',
    viewDetails:'View details',
    projectSupportPlatform:'Project Support Platform',
    name:'Name:',
    phone:'Tel:',
    email:'E-mail:',
    address:'Address:',
  },
  file:{
    trialSteeringCommittee:[
      {
        name:'Xun-Ming Ji',
        position:'Chairman',
        organization:'Xuanwu Hospital of Capital Medical University'
      },
      {
        name:'Hui-Sheng Chen',
        position:'Chief Investigator',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Zhong-He Zhou',
        position:'Senior Trials Manager',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Duo-Lao Wang',
        position:'Medical Statistician',
        organization:'Liverpool School of Tropical Medicine'
      },
      {
        name:'Chang-Hao Jiang',
        position:'Local Investigator',
        organization:'Lvshunkou Distinct People’s Hospital'
      },
      {
        name:'Xiao-Dong Liu',
        position:'Local Investigator',
        organization:'Tonghua Vascular Disease Hospital'
      },
      {
        name:'Xiu-Li Shang',
        position:'Neurologist',
        organization:'The First Affiliated Hospital of China Medical University'
      },
      // {
      //   name:'Jing Li',
      //   position:'Local Investigator',
      //   organization:'Donggang Central Hospital'
      // },
    ],
    institutionHumanResearchEthicsCommittee:[
      {
        name:'Bao-Jun Liu',
        position:'Chief',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Guo-Xu Zhang',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Yun-Hui Li',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Wei Chen',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Hai-Tao Zhao',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Yi Li',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Xin-Wei Liu',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Xing-Shun Qi',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Fang-Ran Xin',
        organization:'General Hospital of Northern Theatre Command'
      },
      {
        name:'Dong Jiang',
        organization:'Liaoning Hehao Law Office'
      },
      {
        name:'Li-Jun Zhang',
        organization:'Community Representative'
      },
    ],
    dataMonitoringCommittee:[
      {
        name:'Yi-Long Wang',
        position:'Chairman',
        organization:'Tiantan Hospital of Capital Medical University'
      },
      {
        name:'Yi Yang',
        position:'Neurologist',
        organization:'The First Affiliated Hospital of Jilin University'
      },
      {
        name:'Ding-Bo Tao',
        position:'Neurologist',
        organization:'The First Affiliated Hospital of Dalian Medical University'
      },
      {
        name:'Xiao-Wen Hou',
        position:'Medical Statistician',
        organization:'Shenyang Medical College'
      },
    ],
    outcomeCommittee:[
      {
        name:'Yi Yang',
        position:'Chairman',
        organization:'The First Affiliated Hospital of Jilin University'
      },
      {
        name:'Ding-Bo Tao',
        position:'Neurologist',
        organization:'The First Affiliated Hospital of Dalian Medical University'
      },
    ],
    protocolV1Url:'https://static.medsci.cn/product/medsci/pdf/OriginalProtocol-EAST-V1.pdf', 
    protocolV2Url:'https://static.medsci.cn/product/medsci/pdf/OriginalProtocol-EAST-V2.pdf', 
    protocolIJOSUrl:'https://static.medsci.cn/product/medsci/pdf/Protocol-IJOS-EAST.pdf',
    planV1Url:'https://static.medsci.cn/product/medsci/pdf/StatisticalAnalysisPlan-EAST-V1.pdf', 
    planV2Url:'https://static.medsci.cn/product/medsci/pdf/StatisticalAnalysisPlan-EAST-V2.pdf', 
    informedConsetUrl:'https://static.medsci.cn/product/medsci/pdf/informedConsent-en.pdf',
    principalInvestigator:'Hui-Sheng Chen: Chief Physician, M.D., Doctoral Supervisor, Director of Department of Neurology of General Hospital of Northern Theater Command, Director of the Clinical Research Center for Cerebrovascular Diseases in Liaoning Province, Director of the Quality Control Center for Stroke in Liaoning Province, Chairman of Liaoning Provincial Cerebrovascular Disease Clinical Collaborative Innovation Alliance, member of the Neurology Branch and Cerebrovascular Disease Group of the Chinese Medical Association, member of China Stroke Association. The main research direction: basic and clinical research of stroke. As the project leader, he has won 1 sub-project of chronic disease special project of the Ministry of National Science and Technology, 2 multi-center projects of the National Health and Family Planning Commission, 5 projects of the National Natural Science Foundation of China, and 5 projects of the Liaoning Provincial Science and Technology Research Project; As the first or corresponding author, he published more than 100 papers (SCI indexed) in several journals, such as JAMA, JAMA Neurology, Nature Communications, Annals of Neurology, JNNP, et al. As the first undertaker, he won 1 second prize of Liaoning Provincial Natural Science Award and 1 second prize of Liaoning Provincial Medical Science and Technology Award.Tel：+86-13352452086.Email：chszh@aliyun.com',
    principalInvestigatorSiteContent:`The General Hospital of Northern Theater Command was approved as the Army Neuromedicine Research Institute in 2006, and became the Liaoning Province Cerebrovascular Disease Translational Medicine Research Center in 2013. Approved by the Liaoning Provincial Science and Technology Department in 2016, the department of neurology took the lead in establishing the Liaoning Province Cerebrovascular Disease Clinical Medicine Collaborative Innovation Alliance. The department has the largest neurological ICU in the country, and treats more than 800 neurologically critical patients every year. The Liaoning Province Cerebrovascular Disease Clinical Medicine Collaborative Innovation Alliance is composed of dozens of tertiary hospitals and grass-roots hospitals in the province, which can effectively guarantee the case screening for this research.
    As the Army Neuromedicine Research Institute, the department has an independent laboratory, which can conduct neurobiochemical, neuropathological, cell culture and other experiments, and the experimental equipment of molecular biology is also gradually improving. Existing equipment includes -40°C and -80°C low-temperature refrigerators, low-temperature cryostats, carbon dioxide incubators, RT-PCR instruments, fluorescent immunological microscopes, ultraviolet spectrophotometers, biochemical electrophoresis instruments, rat brain stereotaxic instruments and routine Laboratory equipment.`
  }
}